// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"903":"6d2464d9","970":"238e6deb"}[chunkId] + ".js";
};